<template>
  <div>
    <div v-for="menuItem in menuItems" :key="menuItem.url" class="mb-4">
      <Link class="group flex items-center py-3" :href="menuItem.url" :method="isLogoutUrl(menuItem.url) ? 'delete' : 'get'" :as="isLogoutUrl(menuItem.url) ? 'button' : undefined">
        <i :class="'fa fa-' + menuItem.icon + ' mr-2 w-4 h-4 ' + (isUrl(menuItem.url) ? 'fill-white text-white' : 'fill-indigo-400 text-indigo-400 group-hover:fill-white')" />
        <div :class="isUrl(menuItem.url) ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
          {{ menuItem.label }}
        </div>
      </Link>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
//import Icon from '@/Shared/Icon'

export default {
  components: {
    // Icon,
    Link,
  },
  data() {
    return {
      menuItems: [],
    }
  },
  created() {
    this.setMenuItems()
  },
  methods: {
    setMenuItems() {
      // we will usee free fontawesome v4, the recent one, we need to pay
      // https://fontawesome.com/v4/icons/
      // most of the menus here still not working
      const accountType = this.$page.props.auth.user.account_type
      if (accountType === 'admin') {
        this.menuItems = [
          { url: '/', icon: 'tachometer', label: 'Dashboard' },
          { url: '/admin/organizations', icon: 'address-book', label: 'Organizations' },
          { url: '/admin/contacts', icon: 'address-card', label: 'Contacts' },
          { url: '/campaigns', icon: 'bullhorn', label: 'Campaigns' },
          { url: '/admin/agents', icon: 'male', label: 'Agents' },
          { url: '/admin/reports', icon: 'pie-chart', label: 'Reports' },
          { url: '/logout', icon: 'eject', label: 'Logout' },
        ]
        // menu for agents, for now they can't see active campaigns to apply, we still lack campaigns, but after we have alot of campaigns, we will allow agents to apply perhaps
      } else if (accountType === 'agent') {
        this.menuItems = [
          { url: '/', icon: 'tachometer', label: 'Dashboard' },
          { url: '/profile', icon: 'male', label: 'Profile' },
          { url: '/campaigns', icon: 'umbrella', label: 'Campaigns' },
          { url: '/logout', icon: 'eject', label: 'Logout' },
        ]
        // menu for the clients
      } else if (accountType === 'client') {
        this.menuItems = [
          { url: '/', icon: 'tachometer', label: 'Dashboard' },
          { url: '/profile', icon: 'address-card', label: 'Profile' },
          { url: '/campaigns', icon: 'bullhorn', label: 'Campaigns' },
          { url: '/reports', icon: 'pie-chart', label: 'Reports' },
          { url: '/logout', icon: 'eject', label: 'Logout' },
        ]
        // menu for the clients admin, with extra billing
      } else if (accountType === 'client_admin') {
        this.menuItems = [
          { url: '/', icon: 'tachometer', label: 'Dashboard' },
          { url: '/profile', icon: 'umbrella', label: 'Profile' },
          { url: '/campaigns', icon: 'bullhorn', label: 'Campaigns' },
          { url: '/invoices', icon: 'umbrella', label: 'Invoices' },
          { url: '/logout', icon: 'eject', label: 'Logout' },
        ]
        // menu for SAAS users, this is for our users, we need to discuss their level, menus, and so on, but this is for the placeholder only
      } else if (accountType === 'account') {
        this.menuItems = [
          { url: '/', icon: 'tachometer', label: 'Dashboard' },
          { url: '/profile', icon: 'umbrella', label: 'Profile' },
          { url: '/campaigns', icon: 'bullhorn', label: 'Campaigns' },
          { url: '/logout', icon: 'eject', label: 'Logout' },
        ]
        // menu for street.report HR department, we will vet, do background check, and perhaps assign agents into campaign members
      } else if (accountType === 'hr') {
        this.menuItems = [
          { url: '/', icon: 'tachometer', label: 'Dashboard' },
          { url: '/profile', icon: 'umbrella', label: 'Profile' },
          { url: '/hr/agents', icon: 'umbrella', label: 'Agents' },
          { url: '/logout', icon: 'eject', label: 'Logout' },
        ]
        // menu for Produced by Deuce, LLC print shop, for now this will input the box contain inventories, later on for managed campaigns, they will able to trade designs with the clients.
      } else if (accountType === 'printshop') {
        this.menuItems = [
          { url: '/', icon: 'tachometer', label: 'Dashboard' },
          { url: '/profile', icon: 'umbrella', label: 'Profile' },
          { url: '/printshop/campaigns', icon: 'umbrella', label: 'Campaigns' },
          { url: '/logout', icon: 'eject', label: 'Logout' },
        ]
      }
    },
    isUrl(url) {
      const currentUrl = this.$page.url === '/' ? '' : this.$page.url
      return currentUrl === (url === '/' ? '' : url)
    },
    isLogoutUrl(url) {
      return url === '/logout'
    },
  },
}
</script>
